import { render } from "./AddJobDocument.vue?vue&type=template&id=587f871c&scoped=true"
import script from "./AddJobDocument.vue?vue&type=script&lang=js"
export * from "./AddJobDocument.vue?vue&type=script&lang=js"

import "./AddJobDocument.vue?vue&type=style&index=0&id=587f871c&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587f871c"]])

export default __exports__